const DURATION = 4000;

@Inject('toastr')
class LspAlertService {
  constructor() {
    this.options = {
      closeButton: false,
      timeOut: DURATION,
      tapToDismiss: true,
    };
  }

  doAlertSuccess(message) {
    this.toastr.success(message, this.options);
  }

  doAlertError(message) {
    this.toastr.error(message, this.options);
  }
}

export default LspAlertService;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-alerts/lsp-alert-service.js